import React, { Component } from "react";
import { isObject } from "lodash";
import ErrorFallback from "./ErrorFallback";

export default class ErrorBoundary extends Component {
  componentDidCatch(error) {
    this.props.onError(isObject(error) ? error : { message: error });
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    return this.props.error ? (
      <ErrorFallback
        resetErrorBoundary={this.props.resetErrorBoundary}
        error={this.props.error}
      />
    ) : (
      this.props.children
    );
  }
}
